import * as React from "react";
function MorningstarSquaredIcon(props: React.SVGProps<any>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} {...props}>
      <g fill="none" fillRule="nonzero">
        <path fill="#F40103" d="M0 0h18v18H0z" />
        <path fill="#FFF" d="M12 4v10h-.996V5.43L9.465 14H8.52L7.004 5.43V14H6V4h1.997l1.042 6.034L9.997 4z" />
      </g>
    </svg>
  );
}
export default MorningstarSquaredIcon;
